export const TZ_USER = Intl.DateTimeFormat().resolvedOptions().timeZone
export const EUROPE_ROME = 'Europe/Rome'

export const timeZone = {
    TZ_USER,
    EUROPE_ROME
}